// extracted by mini-css-extract-plugin
module.exports = {"userCheckboxText":"ListObjectivesPage_userCheckboxText__1rtJm"};